const translationMap = {
	cost: 'project_budget.cost',
	actualCost: 'project_budget.cost',
	actualVsPlanCost: 'project_budget.cost',
	baselineCost: 'project_budget.cost',
	baselineVsActualCost: 'project_budget.cost',
	baselineVsForecastCost: 'project_budget.cost',
	plannedCost: 'project_budget.cost',
	forecastCost: 'project_budget.cost',
	forecastVsPlanCost: 'project_budget.cost',
	remainingCost: 'project_budget.cost',
	revenue: 'project_budget.revenue',
	actualRevenue: 'project_budget.revenue',
	baselineRevenue: 'project_budget.revenue',
	baselineVsActualRevenue: 'project_budget.revenue',
	baselineVsForecastRevenue: 'project_budget.revenue',
	plannedRevenue: 'project_budget.revenue',
	actualVsPlanRevenue: 'project_budget.revenue',
	forecastRevenue: 'project_budget.revenue',
	forecastVsPlanRevenue: 'project_budget.revenue',
	remainingRevenue: 'project_budget.revenue',
	profit: 'project_budget.profit',
	actualProfit: 'project_budget.profit',
	baselineProfit: 'project_budget.profit',
	baselineVsActualProfit: 'project_budget.profit',
	baselineVsForecastProfit: 'project_budget.profit',
	actualVsPlanProfit: 'project_budget.profit',
	plannedProfit: 'project_budget.profit',
	forecastProfit: 'project_budget.profit',
	forecastVsPlanProfit: 'project_budget.profit',
	remainingProfit: 'project_budget.profit',
	invoiced: 'project_budget.invoiced',
	invoicedVsActualRevenue: 'project_budget.accrued',
	retainerPeriodTargetMinutes: 'project_budget.retainer_period_target_minutes',
	retainerPeriodTargetPrice: 'project_budget.retainer_period_target_price',
	margin: 'project_budget.margin',
	paid: 'project_budget.paid',
	registeredMinutes: 'project_budget.time_entries',
	remainingMinutes: 'project_budget.remainingMinutes',
	forecastMinutes: 'project_budget.time_entries',
	allocatedMinutes: 'project_budget.plan',
	baselineMinutes: 'project_budget.time_entries',
	scopeApprovedMinutes: 'project_budget.estimated_scope',
	time: 'project_budget.time',
	baselineVsRegisteredMinutes: 'project_budget.time_entries',
	baselineVsForecastMinutes: 'project_budget.time_entries',
	registeredVsScopeApprovedMinutes: 'common.variance',
	forecastVsScopeApprovedMinutes: 'common.variance',
};

const getAggregateRowTitle = (intl, rowName) => {
	return intl.formatMessage({id: translationMap[rowName] || rowName});
};

export default getAggregateRowTitle;
